<mat-card>
  <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
    <div matCardAvatar *ngIf="showAvatar">
      <glxy-avatar
        [width]="AVATAR_WIDTH"
        icon="question_answer"
        backgroundColor="white"
        textColor="#9E9E9E"
      ></glxy-avatar>
    </div>
    <mat-card-title>
      <span class="title">{{ 'ACTIVITY.COMMUNICATION.CONVERSATION_CREATED' | translate }} {{ sourceName }}</span>
    </mat-card-title>
    <mat-card-subtitle>
      <p *ngIf="effectiveDate !== null" class="effective-date">
        {{ effectiveDate | date : dateFormat }}
      </p>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
    <div *ngIf="body">
      <crm-collapsible-section [maxHeightPx]="100">
        <p class="note-body">{{ body }}</p>
      </crm-collapsible-section>
    </div>
    <div class="link" *ngIf="activityUrl">
      <a [href]="activityUrl">{{ activityUrlName || activityUrl }}</a>
    </div>
  </mat-card-content>
</mat-card>
